module.exports = __webpack_public_path__ + "static/img/plant.70f62bf9.png";